import React from 'react';

import './App.css';
import Playlist from '../../components/Playlist/Playlist.js';
import SearchBar from '../../components/SearchBar/SearchBar.js';
import SearchResults from '../../components/SearchResults/SearchResults.js';
import Spotify from '../../util/Spotify.js';

Spotify.getAccessToken();

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchResults: [],
      playlistName: 'My Playlist',
      playlistTracks: []
    }

    this.addTrack = this.addTrack.bind(this);
    this.removeTrack = this.removeTrack.bind(this);
    this.updatePlaylistName = this.updatePlaylistName.bind(this);
    this.savePlaylist = this.savePlaylist.bind(this);
    this.search = this.search.bind(this);
  }

  search(term) {
   Spotify.search(term)
     .then(searchResults => this.setState({
       searchResults: searchResults
     }));
  }

  updatePlaylistName(name) {
    this.setState({
     playlistName: name
    });
  }

  savePlaylist() {
  const trackUris = this.state.playlistTracks.map(playlistTrack => playlistTrack.uri);
  Spotify.savePlaylist(this.state.playlistName, trackUris);
  this.setState({
    searchResults: []
  });
  this.updatePlaylistName('My playlist');
  console.info(trackUris);
  }

  addTrack(track) {
    if (!this.state.playlistTracks.find(playlistTrack => playlistTrack.id === track.id)) {
      this.setState(prevState => ({
        playlistTracks: [...prevState.playlistTracks, track]
      }));
    }
  }

  removeTrack(track) {
    this.setState({
      playlistTracks: this.state.playlistTracks.filter(playlistTrack => playlistTrack.id !== track.id)
    });
  }

  render() {
    return (
      <div>
        <h1>Ja<span className="highlight">mmm</span>ing</h1>
        <div className="App">
          <SearchBar onSearch={this.search}/>
        <div className="App-playlist">
          <SearchResults searchResults={this.state.searchResults} onAdd={this.addTrack} />
          <Playlist
                name={this.state.playlistName}
                tracks={this.state.playlistTracks}
                onSave={this.savePlaylist}
                onRemove={this.removeTrack}
                onNameChange={this.updatePlaylistName} />

        </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js